import React, { useRef } from "react";
import { PaddedContainer } from "@disco/disco_core";

import useElementInView from "../../hooks/useElementInView";
import { generateProductRowData } from "../LeadGen";
import LeadGenBottomRowElement from "../LeadGen/LeadGenBottomRowElement";
import useData from "../../hooks/useData";

const OfferRow = ({ className = "", parentHPadding, ...rest }) => {
	const data = useData();
	const products = generateProductRowData({ data });
	const parentContainerRef = useRef();

	const { isPartiallyInView } = useElementInView({
		elementRef: parentContainerRef,
	});

	return (
		<PaddedContainer
			className={className}
			ref={parentContainerRef}
			{...rest}
		>
			<PaddedContainer
				style={{
					gap: "8px",
					padding: `0 ${parentHPadding}px`,
					overflow: "auto",
					paddingTop: "4px",
					paddingBottom: "4px",
				}}
				flexContent
			>
				{products.map(({ brand, ...product }, idx) => (
					<LeadGenBottomRowElement
						product={product}
						idx={idx}
						brand={brand}
						parentContainerRef={parentContainerRef}
						isParentInView={isPartiallyInView}
						key={idx}
					/>
				))}
			</PaddedContainer>
		</PaddedContainer>
	);
};

export default OfferRow;
